<template>
  <div class="container">
     <div class="imageBg">
      <img class="mainPic" :src="detail.src" />
      <div v-if="detail.tag" class="tag">{{ detail.tag }}
      </div>
    </div>
     <div class="title"><div>{{detail.title}}</div><div>PRODUCTS CASE</div></div>
     <div class="intro">
      <div>{{ detail.introTitle }}</div>
      <div>{{ detail.subheading }}</div>
      <div>{{ detail.detail }}</div>
     </div>
  </div>
</template>
<script>
export default {
  name: 'Pannel',
  props: {
      detail:{
          type: Object, default() {
          return {}
        }
      },

  },
  data () {
    return {
      img1:require("@/assets/homepage/chery_zhutu@2x.png")
    }
  },

  methods: {

  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 1375px;
  margin-top: 220px;
  border-radius: 24px;
  background-color: #E8EEFC ;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 80px;

  .imageBg {
    position: relative;
  }

  .mainPic{
    width: 1375px;
    height: 684px;
  }


  .tag{
      padding: 18px 19px;
      background: #FFFFFF;
      border-radius: 48px 48px 48px 48px;
      opacity: 1;
      font-size: 24px;
      font-family: "SourceHanSansSC-Bold-2";
      font-weight: bold;
      color: #E43363;
      -webkit-text-stroke: 1px rgba(0,0,0,0);
      // text-stroke: 1px rgba(0,0,0,0);
      position: absolute;
      left:40px;
      bottom: 40px;
    }

  .title{
    // width: 394px;
    height: 186px;
    background: #2A45A7;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    position: absolute;
    top: 0;
    margin-top: -70px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    padding: 0 32px;

    :first-child
      {
        height: 35px;
        font-size: 32px;
        font-family: "SourceHanSansSC-Bold-2";
        font-weight: bold;
        color: #EAFF74;
        display: flex;
        justify-content: space-around;
        align-items: center;

      }

      :nth-child(2)
      {
        margin-left: 32px;
        height: 20px;
        font-size: 20px;
        font-family: "SourceHanSansSC-Bold-2";
        font-weight: bold;
        color: #FFFFFF;
        border-left: 1px solid #FFFFFF;
        height: 102px;
        opacity: 0.2;
        padding-left:24px;
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
  }

  .intro{
    padding-top: 56px;
    text-align: left;

    :first-child
      {
        font-size: 56px;
        font-family: "SourceHanSansSC-Heavy-2";
        font-weight: 800;
        color: #2A45A7;
      }
      :nth-child(2)
      {
        margin-top: 24px;
        font-size: 24px;
        font-family: "SourceHanSansSC-Heavy-2";
        font-weight: 800;
        color: #2A45A7;
      }

      :nth-child(3)
      {
        margin-top: 40px;
        width: 1375px;
        font-size: 24px;
        font-family: "SourceHanSansSC-Medium-2";
        font-weight: 500;
        color: #24262B;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/homepage/childComps/Pannel.vue